import { defaultDictionaryValueMissing } from '../repository';

export type EventKey = 'AllEvents' | 'Date' | 'Status' | 'Location' | 'Price' | 'MoreInfo';

export const getDefaultEventValue = (key: EventKey): string => {
	switch (key) {
		case 'Date':
			return 'Dato';
		case 'Status':
			return 'Status';
		case 'Location':
			return 'Beliggenhed';
		case 'Price':
			return 'Pris';
		case 'MoreInfo':
			return 'Mere info';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
